import React, { useEffect } from 'react';

/**
 * This hook sets the window title when a component gets mounted.
 * When the component gets unmounted the previously used title is restored.
 * @param {string} title
 */
export function useTitle(title: string): void {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;
    return () => {
      document.title = previousTitle;
    };
  }, [title]);
}

// Thanks https://joshwcomeau.com/react/persisting-react-state-in-localstorage
export function useLocalStorageState(defaultValue: any, key: string) {
  const [value, setValue] = React.useState(() => {
    const localStorageValue = window.localStorage.getItem(key);
    return localStorageValue !== null ? JSON.parse(localStorageValue) : defaultValue;
  });

  React.useEffect(() => {
    window.localStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);
  return [value, setValue];
}
